import { FormPartialDataUsPersonInfo } from ".";

export const getUsPersonFormEmptyValues = (): FormPartialDataUsPersonInfo => ({
  ssn: "",
  firstName: "",
  middleName: "",
  lastName: "",
  usPersonSince: "always",
  usPersonDate: undefined
});
